/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { makeStyles } from '@mui/styles';
import { neptunePrimary, neptunePrimaryDark, neutral5 } from 'apollo-react/colors';
import Typography from 'apollo-react/components/Typography';
import React from 'react';
import { batch, useDispatch } from 'react-redux';

import { clearHelpTopicsError, setCurrentQuestion } from '../../../actions/HelpTopicsActions';
import { useTranslation } from '../../../custom-hooks/useTranslation';

const useStyles = makeStyles({
  questionText: {
    borderBottom: `1px dotted ${neptunePrimary}`,
    color: neptunePrimary,
    width: 'fit-content',
    margin: '10px 0',
    display: 'block',
    '&:first-letter': {
      textTransform: 'uppercase',
    },
    '&:hover': {
      color: neptunePrimaryDark,
      cursor: 'pointer',
      borderColor: neptunePrimaryDark,
    },
  },
  frequentlyQuestionContainer: {
    height: 380,
    overflowY: 'auto',
  },
  emptySearch: {
    margin: '10px 0',
    color: neutral5,
  },
});

export const FrequentQuestionsPanel = ({ latestAskedQuestion, setQuestionValue }) => {
  const classes = useStyles();
  const translateString = useTranslation();
  const dispatch = useDispatch();

  const handleChooseFrequentQuestion = (question, id) => {
    setQuestionValue(question);
    batch(() => {
      dispatch(setCurrentQuestion(id));
      dispatch(clearHelpTopicsError);
    });
  };

  return (
    <>
      <Typography variant="title2">{translateString('Frequently Asked Questions')}</Typography>
      <div className={classes.frequentlyQuestionContainer}>
        {latestAskedQuestion.length > 0 ? (
          latestAskedQuestion.map(({ question, id }) => (
            <a
              key={id}
              className={classes.questionText}
              onClick={() => handleChooseFrequentQuestion(question, id)}
            >
              {question}
            </a>
          ))
        ) : (
          <Typography className={classes.emptySearch}>
            {translateString('No searches yet')}
          </Typography>
        )}
      </div>
    </>
  );
};
